const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

const request = async (path, options = {}) => {
  const response = await fetch(`${API_BASE}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
    ...options,
  });
  if (!response.ok) {
    let detail = `HTTP ${response.status}`;
    try {
      const body = await response.json();
      detail = body?.detail || detail;
    } catch (_e) {
      // ignore
    }
    throw new Error(detail);
  }
  return response.json();
};

export const fetchTenantContext = () => request('/api/tenants/context/current');
export const fetchTenants = () => request('/api/tenants');

